import { OperationResultModel } from '@/app/models/application/operationResultModel'
import { OperationResultType } from '@/app/constants/operationResultType'
import { toast } from '@/lib/toasts/api'

export type OperationResultVariant = 'success' | 'warning' | 'error'

// USE WHEN STATUS IS 200 BUT REPONSE GIVE SOME BAD RESULTS
export const resolveOperationResults = (
  data: unknown,
): { variant: OperationResultVariant; message: string | null } => {
  const results: OperationResultModel[] = Array.isArray(data) ? data : []
  const pick = (type: OperationResultType) =>
    results.find((r) => r?.type === type)

  const error = pick(OperationResultType.Error)
  if (error) return { variant: 'error', message: error.message ?? null }

  const success = pick(OperationResultType.Success)
  if (success) return { variant: 'success', message: success.message ?? null }

  const warning = pick(OperationResultType.Warning)
  if (warning) return { variant: 'warning', message: warning.message ?? null }

  return { variant: 'warning', message: null }
}

export const notifyOperationResults = (
  data: unknown,
  t: (key: string) => string,
  keys: Record<OperationResultVariant, string>,
): OperationResultVariant => {
  const { variant, message } = resolveOperationResults(data)
  toast[variant]({ text: message || t(keys[variant]) })
  return variant
}
